export default __webpack_public_path__ + "static/media/exit_icon.017d4684.svg";